<template>
  <div class="flex small-margin-bottom font-primary">
    <div :data-testid="name" class="outfit-layout">
      <div class="outfit-layout--title flex align-center justify-center">
        <span>{{ name }}</span>
        <div class="buttons-wrapper flex">
          <button
            class="btn-sm extremely-small-margin bg-dark-grey"
            @click="$emit('addComment')"
          >
            {{ outfit.comment ? 'Edit Comment' : 'Add Comment' }}
          </button>
          <button
            class="btn-sm extremely-small-margin bg-dark-grey"
            @click="$emit('removeOutfit')"
          >
            {{ name.includes('Outfit') ? 'Remove outfit' : 'Remove extras' }}
          </button>
        </div>
      </div>
      <p class="outfit-description">
        {{ outfit.comment }}
      </p>
      <div class="outfit-layout--products flex">
        <draggable v-model="outfit.products" class="outfit-layout--products flex" @end="onEnd">
          <div
            class="outfit-product relative"
            v-for="product in outfit.products"
            :key="product.variantId"
          >
            <template v-if="product.visible">
              <span class="btn-remove" @click="$emit('onRemove', product.id, product.variantId)">
                <SvgFile name="minus" size="28" color="#5C7069" />
              </span>
              <span
                class="icon-liked"
                v-if="isAccepted(product.variantId)"
              >
                <SvgFile name="heart-with-border" size="28" color="#5C7069" />
              </span>
              <div class="product-brand">
                {{ product.brand ? product.brand.name : "" }}
              </div>
              <div class="img-thumbnail flex justify-center" v-lazy-container="{ selector: 'img' }">
                <img
                  :data-src="product.thumbnail"
                  :alt="product.brand ? product.brand.name : 'Product image'"
                  class="product-image"
                />
              </div>
              <div class="product-price">
                {{
                  product.price.sales_price
                    ? product.price.sales_price
                    : product.price.regular_price
                }}
                {{ product.price.currency }}
              </div>
            </template>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  name: 'Outfit',
  components: {
    draggable
  },
  props: {
    outfit: {
      type: Object
    },
    name: {
      type: String,
      default: ''
    },
    preshippingFeedback: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isAccepted (variantId) {
      const feedback = this.preshippingFeedback.filter((el) => el.variant_id === variantId)
      return feedback && feedback.length > 0 ? feedback[0].accepted : false
    },
    onEnd () {
      if (this.outfit && this.outfit.products.length > 1) {
        const params = this.outfit.products.map((product, index) => {
          return {
            id: product.id,
            sort_order: index + 1
          }
        })
        Vue.api.patch(`/order/${this.$route.query.id}/outfit/${this.outfit.id}/sort`,
          { ...params },
          {
            callback: () => {}
          }
        )
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../styles/variables.less";

.outfit-layout {
  width: 100%;

  .buttons-wrapper {
    display: flex;
    position: absolute;
    right: 5px;
    button {
      border-radius: 6px;
      @media screen and (max-width: 1600px) {
        font-size: 10px;
      }
    }

    .extremely-small-margin {
      margin: 2px;
    }
  }

  &--title {
    background: #F09491;
    height: 54px;
    margin-bottom: 32px;

    span {
      font-size: 26px;
      font-family: @font-primary;
      letter-spacing: 0px;
      color: #000000;
      @media screen and (max-width: 1600px) {
        font-size: 20px;
      }
    }
  }

  .outfit-description {
    max-width: 90%;
    margin: 30px auto 10px auto;
    font-size: 23px;
    color: #000000;
    font-family: @font-primary;
    text-align: center;
  }

  &--products {
    overflow: auto;
    padding: 10px;

    .outfit-product {
      margin-right: 10px;
      box-shadow: 0px 3px 12px #00000029;
      border-radius: 10px;
      padding: 10px;

      .btn-remove {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -5px;
        left: -5px;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
          transform: scale(1.2);
        }
      }

      .icon-liked {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      .product-brand {
        color: #000000;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        margin-top: 10px;
        height: 18px;
      }

      .product-image {
        width: auto;
        height: 150px;
      }

      .product-price {
        font-family: Montserrat;
        color: #000000;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
      }
    }
  }
}
</style>
